
import "./main.css";

import Header from "../components/Header";
import Footer from "../components/Footer";

import { useEffect } from "react";


export default function Main() {

    useEffect(() => { window.scrollTo(0, 0); }, []);

    return(
        <div className="context">
            
            <Header access={0}></Header>
            
            <div className="content">
                <span className="ft_topico">Agentes de IA</span>
                <span className="ft_descricao">Um agente de IA é um programa de software que usa a inteligência artificial para realizar tarefas de forma autônoma. De forma análoga e traduzindo para o mundo real, é como você ter um ajudante que possa te auxiliar em todas as tarefas administrativas repetitivas do seu dia a dia.</span>
                <span className="space"></span>
                <span className="space"></span>
                <span className="ft_topico">Porque um agente de IA pode me ajudar?</span>
                <span className="ft_descricao">Com o grande avanço das tecnologias de inteligência artificial, gradativamente, as tarefas rotineiras estão cada vez mais sendo introduzidas no mercado e sendo delegadas a robôs, que por sua vez, executam estas tarefas com maestria, pontualidade e sem descanso e remuneração.</span>
                <span className="ft_descricao">Inevitavelmente e irretroativamente, as IA's chegaram para ficar e inicialmente estão ocupando um espaço na execução de tarefas operacionais, onde sob alguma supervisão, elas conseguem desempenhar um papel eficaz e preciso.</span>
                <span className="space"></span>
                <span className="space"></span>
                <span className="ft_topico">Mas onde eu entro nessa história?</span>
                <span className="ft_descricao">Se você tem ou trabalha em um estabelecimento onde exija atendimento ao público (seja clientes, pacientes e etc) você necessariamente terá que executar ou contratar alguém que execute as tarefas administrativas, tais como: prestar informações sobre seu trabalho ou atendimento, sobre suas especialidades, consultar sua agenda e ver disponibilidades, marcar e remarcar horários, mostrar cardápios, informar valores e etc.</span>
                <span className="ft_descricao">E é nesse contexto das tarefas administrativas, que podemos ajudar você.</span>
                <span className="space"></span>
                <span className="space"></span>
                <span className="ft_topico">Somos uma empresa que comercializa agentes de IA</span>
                <span className="ft_descricao">Temos soluções para atender a determinados ramos de atividades com nossos agentes, onde eles farão todo o primeiro contato com os clientes, interagindo de forma fluída e não mecânizada.</span>
                <span className="ft_descricao">Nossos agentes são personalizáveis através dessa plataforma e com valores de mensalidade muito acessíveis.</span>
                <span className="space"></span>
                <span className="space"></span>
                <span className="ft_topico">E por onde eu começo?</span>
                <span className="ft_descricao">Clique no link 'Planos' e veja os ramos de atividades que já estamos atendendo, depois veja em 'Como Funciona' e siga quatro passos simples para criar seu agente e testá-lo.</span>
                <span className="space"></span>
                <span className="space"></span>
                <span className="space"></span>
            </div>
            
            <Footer access={0}></Footer>

        </div>
    )
}